import React from 'react';
import {Admin, Resource, GET_LIST, Authenticated} from 'react-admin';
import compose from 'lodash/fp/compose';

import {CrewList} from "./lists/crew";
import {GenreList} from "./lists/genre";
import vmsDataProvider from './data-providers/vms';
import {authProvider, authInterceptor} from './data-providers/auth-provider';
import {addUploadCapabilities} from "./data-providers/add-upload-capabilities";

import {MovieList} from "./lists/movie";
import {PeopleList} from "./lists/people";

import {Label, MusicVideo, RecentActors} from '@material-ui/icons';
import {CrewCreate, CrewEdit} from "./forms/crew-forms";
import {PeopleCreate, PeopleEdit} from "./forms/people-forms";
import {GenreCreate, GenreEdit} from "./forms/genre-form";
import {MovieCreate, MovieEdit} from "./forms/movie-forms";
import {NotFound} from "./pages/not-found";
import {Login} from "./pages/login-page";
import {Menu} from "./components/menu";
import {CollectionsList} from "./lists/collections";
import {CollectionCreate, CollectionEdit} from "./forms/collection-form";

const dataProvider = compose(
    addUploadCapabilities,
    vmsDataProvider,
    authInterceptor
)(fetch);

const staticResources = [
  <Resource name="people" list={PeopleList} icon={RecentActors} edit={PeopleEdit} create={PeopleCreate} />,
  <Resource name="crew" list={CrewList} edit={CrewEdit} create={CrewCreate} />,
  <Resource name="genre" list={GenreList} icon={Label} edit={GenreEdit} create={GenreCreate} />,
  <Resource name="collections" label="Movie Imports"
            list={CollectionsList} edit={CollectionEdit} create={CollectionCreate} />,
  <Resource name="movie" list={MovieList} icon={MusicVideo} edit={MovieEdit} create={MovieCreate} />,
];

const fetchMoviesCollections = (permissions) => {
  console.info("Loading resources", permissions);
  return dataProvider(GET_LIST, 'collections', {})
          .catch( err => Promise.resolve({data: []}))
          .then( ({data}) => data) // it return pagination response by default
          .then( collections => collections.map(({slug, title}) => (
                  <Resource name={`collection/${slug}`}
                            options={{ label: title}}
                            list={MovieList}
                            icon={MusicVideo}
                            edit={MovieEdit} create={MovieCreate} />
          )))
          .then( resources => staticResources.concat(resources));
};

const App = () => (
<Admin catchAll={NotFound} menu={Menu} loginPage={Login} dataProvider={dataProvider} authProvider={authProvider} >
  {fetchMoviesCollections}

</Admin>
);

export default App;
